import { render, staticRenderFns } from "./handle-order-popup.vue?vue&type=template&id=584b33e5&scoped=true&"
import script from "./handle-order-popup.vue?vue&type=script&lang=js&"
export * from "./handle-order-popup.vue?vue&type=script&lang=js&"
import style0 from "./handle-order-popup.vue?vue&type=style&index=0&id=584b33e5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584b33e5",
  null
  
)

export default component.exports